export default __webpack_public_path__ + "static/media/newletterImg.824136df.png";